import { AppHeader, AppHeaderBackButton, Box, Container, Typography } from '@ace-clublabs/shared-component-library';
import { ManageMembershipSection } from '../components/ManageMembershipSection/ManageMembershipSection';
import { useHistory } from 'react-router-dom';
import { Pages } from '../utils/constants';
import { useLayoutEffect, useState } from 'react';
import { BackButtonConfirmModal } from '../components/BackButtonConfirmModal/BackButtonConfirmModal';
import { useGlobalState } from '../state/state';
import { getIsMembershipChanging } from '../state/helpers';
import { hasPITOrPendingChange } from '../utils/ruleHelper';
import { PITWarningModal } from '../components/PITWarningModal/PITWarningModal';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { GreenBoxMessage } from '../components/GreenBox/GreenBoxMessage';

export const ManageMembership: React.FC = () => {
  const history = useHistory();
  const [showBackButtonModal, setShowBackButtonModal] = useState(false);
  const [formData] = useGlobalState('formData');
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [tags] = useGlobalState('tags');
  const hasPITPendingChange = hasPITOrPendingChange(memberDetails);
  const [isTagging, setTagging] = useState(true);
  const [content] = useGlobalState('content');

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'manage');
    setTagging(false);
  }, []);

  const onBackButtonClick = () => {
    const hasMembershipChanged = getIsMembershipChanging(memberDetails, formData);
    if (hasMembershipChanged) {
      setShowBackButtonModal(true);
    } else {
      history.push(Pages.HomePage);
    }
  };

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <Container maxWidth="lg" sx={{
        marginBottom: '0',
        '@media (min-width: 576px) and (max-width: 769px)': { marginBottom: '7rem' },
        }}>
        <Box
          sx={{
            marginTop: '1.5rem',
          }}
        >
          <AppHeader
            backButton={
              !isMobileApp && <AppHeaderBackButton label="Back to my membership" onClick={onBackButtonClick}/>
            }
          />
          <Typography
            variant="h5"
            className="manage-membership-title"
            sx={{ marginTop: '0rem', marginBottom: '1.0rem', fontWeight: 500 }}
          >
            Manage Membership
          </Typography>
          {content.greenBoxMessage && (
            <Typography
              sx={{
                marginBottom: '1rem',
              }}
            >
              <GreenBoxMessage
                shortBoxMessage={content.greenBoxMessage.shortBoxMessage}
                modalTitle={content.greenBoxMessage.modalTitle}
                modalBody={content.greenBoxMessage.modalBody}
              />
            </Typography>
          )}
          <BackButtonConfirmModal
            visible={showBackButtonModal}
            onConfirm={() => {
              setShowBackButtonModal(false);
              history.push(Pages.HomePage);
            }}
            onCancel={() => setShowBackButtonModal(false)}
          />
          <ManageMembershipSection />
        </Box>
      </Container>
      <PITWarningModal
        visible={hasPITPendingChange}
        onClose={() => {
          history.push(Pages.HomePage);
        }}
      />
    </>
  );
};
